import { PropType, computed, defineComponent, nextTick, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import styles from './styles.module.scss'
import { Store } from 'pinia'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import { MapViewMode } from '../../contract/map'
import { clearHistory } from '../../router'
import Tracker from '@nio-fe/nio-tracker-web'
import { isInApp } from '@nio-wad/hooks'

// Sleep utility function
const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

export default defineComponent({
  name: 'second-action-icon',
  props: {
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },
  setup: (props) => {
    if (window.client !== 'mobile') {
      return
    }
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    // 获取组件配置
    const router = useRouter()
    const route = useRoute()
    // const route = useRoute()
    const state = reactive({
      showIcon: true,
      clickAble: true,
      currentIconName: '',
    })

    const tempDisable = async () => {
      state.clickAble = false
      await sleep(3000)
      state.clickAble = true
    }

    const handleBackHome = async () => {
      if (!state.clickAble) {
        // 防止多次点击
        return
      }
      console.log('====================================')
      console.log('handleBackHome')
      console.log('====================================')
      props.componentStore.bus.emit('destroyCountyLayout')

      if (route.name === 'resource') {
        // 在县县通下点击资源ICON然后再点布局，需要back 2次
        window.backHistoryNum--
        await router.back()
        await sleep(100)
        // 手机上表现只能back一次，需要延迟再处理一次
        window.backHistoryNum--
        await router.back()
      } else {
        window.backHistoryNum--
        await router.back()
      }
      console.log('==============布局=====handleBackHome=================')
      console.log(window.backHistoryNum)
      console.log('====================================')
      props.componentStore.bus.emit('displayInformationByConfig')
      await tempDisable()
    }

    const handleCountyLayout = async () => {
      if (!state.clickAble) {
        // 防止多次点击
        return
      }
      clearHistory()
      window.backHistoryNum++
      await router.push({
        name: 'countyLayout',
        state: {
          backHistoryNum: window.backHistoryNum,
        },
      })
      await tempDisable()
      Tracker.track('h5_page_tracker', {
        channel: window.channel,
        client: window.client,
        brand: (process.config as any).brand,
        screen_orientation: window.screen_orientation,
        view_mode: props.componentStore.viewMode,
        container: window.container,
        user_identity: window.user_identity,
        trigger: 'click',
        element: '数据页-县县通按钮',
        page_source: window.page_source,
      })
    }

    const showCountyLayoutBtnInSummary = computed(() => {
      // 首页模式 + 显示概览 + 可以查看县县通
      return (
        props.componentStore.viewMode === MapViewMode.Init &&
        props.componentStore.showSummary &&
        componentsConfig.county_layout?.show
      )
    })

    const showCountyLayoutRedDot = computed(() => props.componentStore.showCountyLayoutRedDot)

    return () => {
      return (
        <>
          {state.showIcon ? (
            <div>
              {props.componentStore.viewMode === MapViewMode.CountyLayout ? (
                <div class={styles.rightTop}>
                  <div class={styles.icon} onClick={handleBackHome}>
                    <ns-icon name={(process.config as any).icon.powermap2} size={20} />
                    <span>布局</span>
                  </div>
                </div>
              ) : null}
              {showCountyLayoutBtnInSummary.value ? (
                <div class={styles.rightTop}>
                  <div class={styles.icon} onClick={handleCountyLayout}>
                    <ns-icon name={(process.config as any).icon.icon_county} size={20} />
                    <span>县县通</span>
                    {isInApp && showCountyLayoutRedDot.value ? (
                      <div class={styles.redDot}></div>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </div>
          ) : null}
        </>
      )
    }
  },
})
